import React from 'react';
import styles from './BackButton.module.scss';
import SVG from 'react-inlinesvg';
import arrowLeft from '@/assets/svg/left-arrow.svg';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';

interface BackButtonProps {
  onClick: () => void;
}

const BackButton: React.FC<BackButtonProps> = ({ onClick }) => {
  const { t } = useAdminTranslation();

  return (
    <button
      type='button'
      className={styles.backBtn}
      aria-label={String(t('common.back'))}
      onClick={onClick}
    >
      <SVG className={styles.backBtnIcon} src={arrowLeft} width={20} height={20} />
      <span className={styles.backBtnText}>{t('common.back')}</span>
    </button>
  );
};

export default BackButton;
